"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGO = void 0;
exports.LOGO = 'https://assets.prohabits.com/constants/ph-logo.png';
//# sourceMappingURL=images.js.map